import { toast } from 'react-toastify';

import { isArray } from 'lodash';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import { requestTranslate } from '../language/actions';
import { signInSuccess, signFailure } from './actions';

export function* signIn({ payload }) {
  try {
    const { usuario, senha } = payload;
    let { subdominio } = payload;

    if (process.env.NODE_ENV === 'development' && subdominio === 'localhost') {
      // subdominio = 'aperam';
      // subdominio = 'wd';
      // subdominio = 'cbmsa';
      // subdominio = 'agropeu';
      subdominio = 'unidata';
      // subdominio = 'dragaodomar';
    }

    yield fetch('config.json', {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.URL_BACKEND.length > 0) {
          api.defaults.baseURL = data.URL_BACKEND;
          sessionStorage.setItem('URL_BACKEND', data.URL_BACKEND);
          sessionStorage.setItem('URL_REPORT', data.URL_REPORT);
        } else {
          api.defaults.baseURL = process.env.REACT_APP_URL_REQUEST;
          sessionStorage.setItem(
            'URL_BACKEND',
            process.env.REACT_APP_URL_REQUEST
          );
          sessionStorage.setItem(
            'URL_REPORT',
            process.env.REACT_APP_URL_DOWNLOAD
          );
        }
      })
      .catch(function (err) {});

    const { data } = yield call(api.post, 'logins', {
      subdominio,
      usuario,
      senha,
    });

    const user = {
      id: data.idusuario,
      name: data.nomeusuario,
      client: data.idcliente,
      username: data.codigousuario,
      nomeperfil: data.nomeperfil,
      usuarioPosto: data.usuarioPosto,
    };

    api.defaults.headers.token = data.token;

    yield put(
      signInSuccess(
        data.token,
        user,
        data.modulos,
        data.configgeral,
        "pt-BR"
      )
    );
    yield put(requestTranslate());

    history.push('/dashboard');
  } catch (err) {
    if (isArray(err)) err.map((e) => toast.error(t(e)));
    else toast.error(t(err));

    yield put(signFailure());
  }
}

export function setToken({ payload }) {
  if (!payload) return;

  const { token } = payload.auth;

  if (token) {
    api.defaults.headers.token = token;
  }
}

export function signOut() {
  history.push('/');
}

export default all([
  takeLatest('persist/REHYDRATE', setToken),
  takeLatest('@auth/SIGN_IN_REQUEST', signIn),
  takeLatest('@auth/SIGN_OUT', signOut),
]);
